// initial state
const state = () => ({
    albums: [],
    uploadProgress: null
})

// getters
const getters = {
}

// actions
const actions = {
    getAlbums: async({ commit }) => {
        let { data } = await axios.get('album');
        commit('setAlbums', data);
    },

    updateAlbum: async({ state, commit }, album) => {
        console.log('updateAlbum', album, album.name);
        let { data } = await axios.put('album/' + album.id, {
            name: album.name
        });
        // commit('setAlbums', data);
    },

    storeAlbum: async({ state, commit }, album) => {
        console.log('storeAlbum', album);
        let { data } = await axios.post('album', album);
        // commit('storeAlbum', data);
    },

    uploadAlbumArt: async ({ commit }, payload) => {
        commit('setUploadProgress', 0);

        try {
            let { data } = await axios.post('album/cover', payload, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress:(progressEvent) => {
                    commit('setUploadProgress', parseInt(Math.round(progressEvent.loaded / progressEvent.total) * 100));
                }
            });

            commit('setUploadProgress', null);
            return data;
        } catch (error) {
            commit('setUploadProgress', null);
            throw error.response.data?.message || 'Something went wrong';
        }
    },
}

// mutations
const mutations = {
    setAlbums(state, payload) {
        state.albums = payload;
    },

    setLibraryTrackOwned(state, data) {
        let album = state.albums.find(album => album.id === data.album_id);

        let track = album.tracks.find(track => track.id === data.id);

        track.track = data.track;
    },

    setUploadProgress(state, data) {
        state.uploadProgress = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
